/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { definitions } from "../generated/orders-model-api";

export function checkPostalCodeInvalid(
  errorsGroup: definitions["OrderError"][]
) {
  const errorCodes = errorsGroup.map((error) => error.errorCode);

  return (
    errorCodes?.includes("AddressPostalCodeInvalidForCountry") ||
    errorCodes?.includes("AddressPostalCodeFormatInvalidForCountry")
  );
}
